<template>
  <div class="main">
    <div class="main_header">
      <!-- <div class="header_item">
        <span class="header_label">班组名称：</span>
        <el-input v-model="search.teamName" :size="size" clearable placeholder="请输入项目名称"></el-input>
      </div> -->
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button icon="el-icon-plus" v-if="showButton('add')" @click="addButtonInfo(true)">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <div class="card-container">
        <div class="card-header">
          <div class="card-header-item">工序班组</div>
          <div class="card-header-item">白班人员</div>
          <div class="card-header-item">夜班人员</div>
        </div>
        <div class="card-body">
          <div v-for="(item, index) in dataList" :key="index" class="card-row">
            <div class="card-cell group-cell">{{ item.teamName }}</div>
            <div class="card-cell">
              <div class="user-tags">
                <el-tag
                 :key="user.userId"
                 v-for="user in item.teamUserList.filter(iten=>iten.userType === 1)"
                  closable
                  type="info"
                  :disable-transitions="false"
                  @close="handleClose(user)">
                  {{ user.userName }}
                </el-tag>
                <el-button style="background-position: center;"  v-if="showButton('insert')" size="mini" @click="openUserDialog('day', item)">选择人员</el-button>
              </div>
            </div>
            <div class="card-cell">
              <div class="user-tags">
                <el-tag
                 :key="user.userId"
                 v-for="user in item.teamUserList.filter(iten=>iten.userType === 2)"
                  closable
                  type="info"
                  :disable-transitions="false"
                  @close="handleClose(user)">
                  {{ user.userName }}
                </el-tag>
                <el-button style="background-position: center;" v-if="showButton('insert')" size="mini" @click="openUserDialog('night', item)">选择人员</el-button>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="card-footer">
          共 {{ total }} 条
        </div> -->
      </div>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog user-select-dialog"
      title="选择人员"
      :close-on-click-modal="false"
      :visible.sync="userDialogVisible"
      width="45%">
      <div class="user-dialog-header">
        <el-input v-model="searchUser" placeholder="搜索姓名/工号" clearable size="small"></el-input>
      </div>
      <div class="user-dialog-body">
        <el-checkbox-group v-model="selectedUserIds">
          <div v-for="user in filteredUsers" :key="user.userId" class="user-checkbox-item">
            <el-checkbox :label="user.userId"> {{ user.realName }}</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <div slot="footer">
        <el-button @click="userDialogVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="confirmUserSelect(currentRow.teamId)">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize, } from '../../plugins/public';
export default {
    data() {
      return {
        size: changeSize(),
        pageNum: 1,
        pageSize: 10,
        search:{},
        total: 0,
        loading: false,
        dataList: [],
        allUsers: [],
        searchUser: '',
        userDialogVisible: false,
        selectedUserIds: [],
        currentRow: null,
        currentType: '',
        teamUserData: {},
      }
    },
    computed: {
      filteredUsers() {
        if (!this.searchUser) return this.allUsers;
        return this.allUsers.filter(user => 
          user.realName.includes(this.searchUser)
        );
      }
    },
    mounted() {
      const that = this;
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
      that.getAllUsers();
    },
    methods: {
      getAllUsers() {
        this.$api.Personnerl.GETSTAFFALLDATA().then(res => {
          if(res.statusMsg === 'ok') {
            this.allUsers = res.data;
          }
        });
      },
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = true;
        this.total = 4;
        this.$api.Group.searchGroupList(params).then(res => {
          if(res.statusMsg === 'ok') {
            console.log(res.data);
            this.dataList = res.data.list.map(item => ({
              ...item,
              dayUsers: (item.teamUserList || []).filter(u => u.userType === 1).map(u => ({
                userId: u.userId,
                userNo: u.userNo,
                realName: u.realName,
              })),
              nightUsers: (item.teamUserList || []).filter(u => u.userType === 2).map(u => ({
                userId: u.userId,
                userNo: u.userNo,
                realName: u.realName,
              })),
            }))
          }
        });
        // this.dataList = [
        //   {
        //     id: 1,
        //     groupName: '拆模生产班组',
        //     dayUsers: [
        //     ],
        //     nightUsers: [
        //     ],
        //     selectedDayUsers: [],
        //     selectedNightUsers: [],
        //   },
        //   {
        //     id: 2,
        //     groupName: '清模生产班组',
        //     dayUsers: [
        //     ],
        //     nightUsers: [
        //     ],
        //     selectedDayUsers: [],
        //     selectedNightUsers: [],
        //   },
        //   {
        //     id: 3,
        //     groupName: '合模生产班组',
        //     dayUsers: [
        //     ],
        //     nightUsers: [
        //     ],
        //     selectedDayUsers: [],
        //     selectedNightUsers: [],
        //   },
        //   {
        //     id: 4,
        //     groupName: '收面生产班组',
        //     dayUsers: [
        //     ],
        //     nightUsers: [
        //       // { userId: '9', userNo: '009', realName: '赵六' },
        //       // { userId: '10', userNo: '010', realName: '郑十' },
        //     ],
        //     selectedDayUsers: [],
        //     selectedNightUsers: [],
        //   },
        // ];
        this.loading = false;
      },
      openUserDialog(type, row) {
        this.currentType = type;
        this.currentRow = row;
        if (type === 'day') {
          this.selectedUserIds = row.dayUsers.map(item => item.userId);
        } else {
          this.selectedUserIds = row.nightUsers.map(item => item.userId);
        }
        this.userDialogVisible = true;
      },
      confirmUserSelect: throttle(function(teamId){
        if (!this.teamUserData[teamId]) {
          this.teamUserData[teamId] = {};
        }
        if (!this.teamUserData[teamId].arrDay || this.teamUserData[teamId].arrDay.length === 0) {
          this.teamUserData[teamId].arrDay = this.currentRow.dayUsers.map(item => ({
            userId: item.userId,
            userType: 1,
          }));
        }
        if (!this.teamUserData[teamId].arrNight || this.teamUserData[teamId].arrNight.length === 0) {
          this.teamUserData[teamId].arrNight = this.currentRow.nightUsers.map(item => ({
            userId: item.userId,
            userType: 2,
          }));
        }
        
        if (this.currentType === 'day') {
          this.selectedUserIds.forEach(item => {
            let user = this.allUsers.find(user => user.userId === item);
            if(user) {
              const exists = this.currentRow.dayUsers.some(u => u.userId === user.userId);
              const existsInArr = this.teamUserData[teamId].arrDay.some(u => u.userId === user.userId);
              if (!exists) {
                this.currentRow.dayUsers.push(user);
              }
              if (!existsInArr) {
                this.teamUserData[teamId].arrDay.push({
                  userId: user.userId,
                  userType: 1,
                });
              }
            }
          });
          let params = Object.assign({},this.currentRow)
          params.teamUserList = this.getUniqueTeamUserList(teamId);
          this.$api.Group.insertGroupOrUpdate(params).then(res => {
            if(res.statusMsg === 'ok') {
              this.$message.success('保存成功');
              this.searchButtonInfo(true);
            }else{
              this.$message.warning(res.statusMsg);
            }
          })
        } else {
          this.selectedUserIds.forEach(item => {
            let user = this.allUsers.find(user => user.userId === item);
            if(user) {
              const exists = this.currentRow.nightUsers.some(u => u.userId === user.userId);
              const existsInArr = this.teamUserData[teamId].arrNight.some(u => u.userId === user.userId);
              if (!exists) {
                this.currentRow.nightUsers.push(user);
              }
              if (!existsInArr) {
                this.teamUserData[teamId].arrNight.push({
                  userId: user.userId,
                  userType: 2,
                });
              }
            }
          });
          let params = Object.assign({},this.currentRow)
          params.teamUserList = this.getUniqueTeamUserList(teamId);
          this.$api.Group.insertGroupOrUpdate(params).then(res => {
            if(res.statusMsg === 'ok') {
              this.$message.success('保存成功');
              this.searchButtonInfo(true);
            }else{
              this.$message.warning(res.statusMsg);
            }
          })
        }
        this.userDialogVisible = false;
      }, 3000),

      getUniqueTeamUserList(teamId) {
        const allUsers = [...(this.teamUserData[teamId].arrDay || []), ...(this.teamUserData[teamId].arrNight || [])];
        const seen = new Set();
        return allUsers.filter(item => {
          const key = `${item.userId}-${item.userType}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
      },

      handleClose: throttle(function(user){
        console.log(user,'关闭用户')
        let params = {
          teamUserId: user.teamUserId,
        }
        this.$api.Group.deleteGroupUser(params).then(res => {
          if(res.statusMsg === 'ok') {
            this.$message.success('删除成功');
            this.searchButtonInfo(true);
          }else{
            this.$message.warning(res.statusMsg);
          }
        })
        // if (this.currentType === 'day') {
        //   this.currentRow.dayUsers = this.currentRow.dayUsers.filter(item => item.userId !== user.userId);
        // } else {
        //   this.currentRow.nightUsers = this.currentRow.nightUsers.filter(item => item.userId !== user.userId);
        // }
      }, 1500),



      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';

.card-container {
  width: 100%;
  background: rgba(10, 36, 82, 0.6);
  border-radius: 8px;
  overflow: hidden;
}

.card-header {
  display: flex;
  background: rgba(57, 181, 254, 0.2);
  padding: 12px 20px;
  border-bottom: 1px solid rgba(57, 181, 254, 0.3);
  
  .card-header-item {
    flex: 1;
    text-align: center;
    color: #39B5FE;
    font-weight: 600;
    font-size: 14px;
  }
}

.card-body {
  padding: 10px 20px;
  
  .card-row {
    display: flex;
    padding: 15px 0;
    border-bottom: 1px dashed rgba(57, 181, 254, 0.2);
    
    &:last-child {
      border-bottom: none;
    }
    
    .card-cell {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      
      &.group-cell {
        justify-content: center;
        color: #fff;
        font-weight: 500;
      }
    }
    
    .user-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      align-items: center;
      
      .user-tag {
        padding: 4px 12px;
        border-radius: 4px;
        font-size: 12px;
        cursor: default;
        
        &.selected {
          background: #39B5FE;
          color: #fff;
        }
        
        &:not(.selected) {
          background: rgba(100, 100, 100, 0.3);
          color: #ccc;
        }
      }
    }
  }
}

.card-footer {
  padding: 12px 20px;
  text-align: center;
  color: #999;
  font-size: 12px;
  background: rgba(10, 36, 82, 0.4);
}

.user-select-dialog {
  ::v-deep .el-dialog__body {
    padding: 15px 24px;
  }
  
  .user-dialog-header {
    margin-bottom: 15px;
  }
  
  .user-dialog-body {
    max-height: 300px;
    overflow-y: auto;
    
    .user-checkbox-item {
      display: flex;
      align-items: center;
      padding: 8px 0;
      border-bottom: 1px dashed rgba(57, 181, 254, 0.1);
      
      ::v-deep .el-checkbox {
        color: #fff;
      }
    }
  }
}
</style>